var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_886_10551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_886_10551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0651 18.8333L15.6243 17.4053C14.9599 17.8871 14.2382 18.2595 13.4593 18.5224C12.6804 18.7852 11.861 18.9166 11.001 18.9166C9.90583 18.9166 8.87666 18.7087 7.91347 18.293C6.95027 17.8775 6.11242 17.3135 5.39992 16.601C4.68742 15.8885 4.1234 15.0506 3.70784 14.0874C3.29215 13.1242 3.0843 12.0951 3.0843 10.9999C3.0843 10.1399 3.21569 9.32047 3.47846 8.54159C3.74138 7.7627 4.11374 7.04103 4.59555 6.37659L3.15492 4.93575C3.0309 4.81186 2.96756 4.66471 2.96492 4.49429C2.96228 4.32388 3.02562 4.17402 3.15492 4.04471C3.28409 3.91554 3.43256 3.85096 3.60034 3.85096C3.76812 3.85096 3.91659 3.91554 4.04576 4.04471L17.9562 17.9551C18.0801 18.079 18.1433 18.224 18.146 18.3901C18.1486 18.5562 18.0853 18.7039 17.9562 18.8333C17.8269 18.9626 17.6783 19.0272 17.5106 19.0272C17.3429 19.0272 17.1944 18.9626 17.0651 18.8333ZM11.001 17.6666C11.6836 17.6666 12.3369 17.5662 12.961 17.3653C13.5849 17.1645 14.1714 16.8766 14.7205 16.5016L5.4993 7.28034C5.1243 7.8295 4.83638 8.41603 4.63555 9.03992C4.43471 9.66395 4.3343 10.3173 4.3343 10.9999C4.3343 12.8471 4.9836 14.4201 6.28222 15.7187C7.58083 17.0173 9.15374 17.6666 11.001 17.6666ZM11.001 4.33325C10.5078 4.33325 10.0258 4.38506 9.55492 4.48867C9.08409 4.59228 8.63235 4.74777 8.19972 4.95513C8.03624 5.03096 7.87013 5.0429 7.70138 4.99096C7.53249 4.93915 7.4059 4.84061 7.32159 4.69534C7.23715 4.55006 7.21951 4.39436 7.26867 4.22825C7.31784 4.06214 7.41985 3.94117 7.57472 3.86533C8.10569 3.61006 8.65666 3.41589 9.22763 3.28284C9.79874 3.14978 10.3899 3.08325 11.001 3.08325C12.0961 3.08325 13.1253 3.2911 14.0885 3.70679C15.0517 4.12235 15.8895 4.68638 16.602 5.39888C17.3145 6.11138 17.8785 6.94922 18.2941 7.91242C18.7098 8.87561 18.9176 9.90478 18.9176 10.9999C18.9176 11.6163 18.8511 12.2114 18.7181 12.7851C18.585 13.3589 18.3882 13.9139 18.1276 14.4503C18.0533 14.6052 17.9314 14.7058 17.7618 14.7522C17.5922 14.7987 17.4348 14.7798 17.2895 14.6953C17.1442 14.611 17.0457 14.4844 16.9939 14.3155C16.9419 14.1468 16.9539 13.9807 17.0297 13.8172C17.2371 13.3792 17.3952 12.9254 17.5041 12.456C17.6131 11.9864 17.6676 11.501 17.6676 10.9999C17.6676 9.1527 17.0183 7.57978 15.7197 6.28117C14.4211 4.98256 12.8482 4.33325 11.001 4.33325Z",
    fill: "#D32F2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/deactivate-icon.c1315a98c362325e1580a30a463798aa.svg";
export { ForwardRef as ReactComponent };